import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';
 

 
class DivisionInfoContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            divisions : [],
            division_info : [],
            loading : 1 ,
            showModal: false, // 👈 for popup
            selectedImage: null, // 👈 to store clicked image
        }
    }

      // 👇 Open popup
    handleImageClick = (image) => {
        this.setState({ showModal: true, selectedImage: image });
    };

    // 👇 Close popup
    closeModal = () => {
        this.setState({ showModal: false, selectedImage: null });
    };
 
    componentDidMount()
    {
         this.setState({loading:0});
         console.log(this.props.division.description2);
       
    } 


    render()
    { 
        
        if (this.state.loading == 1) {
            return <div>Loading...</div>;
          }
    return (
        
        <div>

             <div class="section-full p-t80 p-b0 bg-white">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-5 col-md-8 m-b30">
                            <div class=" ">
                                <img src={this.props.division.image} alt={this.props.division.title} class="img-responsive"  />
                            </div>
                        </div>
                        <div class="col-lg-7 col-md-12 m-b0">
                            <div class="section-head text-left">
								<img src={this.props.division.logo} alt={this.props.division.title} style={{width:"200px"}} />

                                 <div dangerouslySetInnerHTML={{ __html: this.props.division.description}} /> 
                            </div>
                            
                        </div>
						
                    </div>
                     <div class="row">
                        <div class="col-lg-12 col-md-12 m-b0">
                            <div class="section-head text-left"> 
                                 <div dangerouslySetInnerHTML={{ __html: this.props.division.description2}} /> 
                            </div>
                            
                        </div>
                        </div>
					
					
					
					
					
                </div>
            </div>   
             
            <div class="section-full p-t10 p-b50">
                <div class="container">
                
                    
                    
                    
                    
                    <div class="portfolio-wrap mfp-gallery no-col-gap row">
                    { this.props.division.gallery_images.map((gal, index) => (
                        <div class="masonry-item cat-1 col-lg-4 col-md-4 col-sm-6 col-xs-6">
                            <div class="wt-gallery-bx p-a15">
                                <div class="wt-thum-bx wt-img-overlay5 wt-img-effect blurr">
                                    <a href="portfolio-detail.html">
                                        <img src={gal}  alt="" />
                                    </a>
                                    <div class="overlay-bx">
                                        <div class="overlay-icon">
                                            
                                            <Link href={gal} class="mfp-link"  onClick={() => this.handleImageClick(gal)}>
                                                <i class="fa fa-arrows-alt wt-icon-box-xs"></i>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                                     
                         ))}
                </div>
            </div>
             
          
                    
                </div>
    {/* 👇 Popup modal */}
        {this.state.showModal && (
          <div className="modal-overlay" onClick={this.closeModal}>
            <div
              className="modal-content div-modal-content"
              onClick={(e) => e.stopPropagation()} // prevent close on content click
            >
              <span className="close-btn" onClick={this.closeModal}>
                &times;
              </span>
              <img
                src={this.state.selectedImage}
                alt="Certificate"
                className="modal-image"
              />
            </div>
          </div>
        )}

        </div>
    );
}

}

export default DivisionInfoContent;